import React from 'react';
import { Doughnut } from 'react-chartjs-2';

interface GraphicProps {
  title?: string;
  data: { [key: string]: number };
}

const Chart: React.FC<GraphicProps> = ({ data, title }) => {
  const header = title
    ? [
      `${Object.values(data).reduce(function (acc, val) {
        return acc + val;
      }, 0)}`,
    ]
    : [];

  return (
    <Doughnut
      width={1}
      height={1}
      options={{
        animation: {
          animateRotate: true,
          easing: 'easeOutElastic',
          duration: 2000,
        },
        maintainAspectRatio: true,
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: header,
          position: 'bottom',
          fontColor: '#f4f4f4',
        },
      }}
      data={{
        datasets: [
          {
            data: Object.values(data),
            backgroundColor: [
              'rgba(153, 102, 255, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 99, 132, 1)',
            ],
            borderColor: [
              'rgba(153, 102, 255, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 99, 132, 1)',
            ],
            borderWidth: 1,
          },
        ],
        labels: Object.keys(data),
      }}
    />
  );
};

export default Chart;
